import * as React from "react"

const Slider = React.forwardRef(
  ({ className, min = 0, max = 100, step = 1, value = [0], onValueChange, ...props }, ref) => {
    const handleChange = (event) => {
      const newValue = parseFloat(event.target.value)
      onValueChange?.([newValue])
    }

    // Use the first value if an array is provided
    const currentValue = Array.isArray(value) ? value[0] : value

    return (
      <div className="relative flex w-full touch-none select-none items-center" {...props}>
        <div className="relative w-full h-2">
          <div className="absolute h-2 w-full rounded-full bg-gray-800">
            <div
              className="absolute h-full rounded-full themeSecondary"
              style={{
                width: `${((currentValue - min) / (max - min)) * 100}%`,
              }}
            />
          </div>
          <input
            ref={ref}
            type="range"
            min={min}
            max={max}
            step={step}
            value={currentValue}
            onChange={handleChange}
            className={`absolute w-full h-2 appearance-none bg-transparent cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:themeSecondary [&::-moz-range-thumb]:h-4 [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:themeSecondary [&::-moz-range-thumb]:border-0 ${
              className || ""
            }`}
          />
        </div>
      </div>
    )
  }
)

Slider.displayName = "Slider"

export { Slider }